module.exports = __webpack_public_path__ + "img/hotel-icon.ae3f7846.svg";